/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from "react";
import { useOnlineStatus } from "../utils/connectivity";

const OfflineContext = createContext(null);

export function OfflineProvider({ children }) {
  const value = useOnlineStatus();
  return (
    <OfflineContext.Provider value={value}>{children}</OfflineContext.Provider>
  );
}

/** @returns {{ isOnline: boolean, pendingCount: number, syncing: boolean, refreshPending: () => void }} */
export function useOffline() {
  const ctx = useContext(OfflineContext);
  if (!ctx) throw new Error("useOffline must be used within OfflineProvider");
  return ctx;
}
